import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { STATE_COLOR, STATE_LABEL, STUDENT_BLOCKER_TEXT, blockerText } from "./ahaText";

/** One student's AHA state on the roster: request state when there is one, otherwise readiness. */
export default function AhaStatusChip({ item }) {
  if (!item) return null;
  if (item.issuanceStuck && ["PENDING", "SENDING"].includes(item.issuanceState)) {
    const label = item.issuanceState === "PENDING" ? "AHA: Stuck in queue" : "AHA: Stuck sending";
    return (
      <Tooltip title="This card request has waited far longer than a send takes.">
        <Chip size="small" color="warning" label={label} sx={{ height: 20, fontSize: 11, fontWeight: 600 }} />
      </Tooltip>
    );
  }
  if (item.issuanceState && STATE_LABEL[item.issuanceState]) {
    const rejectedNote = item.issuanceState === "REJECTED" && item.providerMessage ? ` — AHA said: ${item.providerMessage}` : "";
    return (
      <Tooltip title={`AHA: ${STATE_LABEL[item.issuanceState]}${rejectedNote}`}>
        <Chip size="small" color={STATE_COLOR[item.issuanceState]} label={`AHA: ${STATE_LABEL[item.issuanceState]}`}
          sx={{ height: 20, fontSize: 11, fontWeight: 600 }} />
      </Tooltip>
    );
  }
  if (item.eligible) {
    return <Chip size="small" color="success" variant="outlined" label="Ready for AHA" sx={{ height: 20, fontSize: 11, fontWeight: 600 }} />;
  }
  const reasons = (item.blockers || []).map((b) => STUDENT_BLOCKER_TEXT[b] || blockerText(b));
  return (
    <Tooltip title={reasons.join(" · ")}>
      <Chip size="small" variant="outlined" label={reasons[0] || "Not ready"}
        sx={{ height: 20, fontSize: 11, fontWeight: 600, maxWidth: 220 }} />
    </Tooltip>
  );
}
